module.exports = __webpack_public_path__ + "img/img19.1223ec96.jpg";